exports.tbsaFormulas = {
  mosteller: {
    code: 'mosteller',
    display: 'Mosteller',
  },
  duBois: {
    code: 'duBois',
    display: 'Du Bois',
  },
};